import { categoryNames } from 'components/common/JobProfileWidget/text'
import { getDisplayCompetencies } from 'utils/categories'
import { getLanguages } from 'utils/languages'

const getPickedCompetencies = competencies =>
  Object.entries(competencies ?? {})
    .filter(([name, value]) => value === true && name)
    .map(([name]) => name)

const getLabels = (names: Record<string, [string, string, string[], string]>) =>
  Object.entries(names).map(([name, [label]]) => ({ label, name }))

export const getLanguageLabels = languages => {
  const labels = getLanguages()

  return labels
    .filter(({ label, value }) => languages.includes(value) && label)
    .map(({ label }) => label)
    .join(', ')
}

export const getCompetenciesLabels = (competencies, language) => {
  const names = getPickedCompetencies(competencies)
  const labels = getLabels(categoryNames(language))

  const selectedLabels = labels
    .filter(({ name }) => names.includes(name))
    .map(({ label }) => label)

  return selectedLabels.map((label, idx) =>
    idx < selectedLabels.length - 1 ? `${label},` : label,
  )
}

const withSeparators = labels =>
  labels.map((label, idx) => (idx < labels.length - 1 ? `${label},` : label))

/**
 * The competency labels to show for a job profile.
 *
 * A profile can name the competencies its report presents, in which case they
 * are shown in the order it lists them. Otherwise the competencies selected for
 * scoring are shown, as they always have been.
 */
export const getProfileCompetenciesLabels = (profile, language) => {
  const shown = getDisplayCompetencies(profile)

  if (!shown) {
    return getCompetenciesLabels(profile?.categories, language)
  }

  const names = categoryNames(language)

  return withSeparators(shown.map(name => names[name]?.[0]).filter(Boolean))
}
